import {Injectable} from '@angular/core';
import {BaseHashService} from '@aam/angular-security';

@Injectable({
  providedIn: 'root',
})
export class HashService extends BaseHashService {}
